import { scrollAnimation } from './function/scroll-animation.js';
const slick = require('/assets/js/slick/slick.js');
import '/assets/js/common.js';
import '/assets/css/slick/slick.css';
import '/assets/css/_common.scss';
import '/assets/css/service.scss';

// ===========================================
// スクロールアニメーションのオプション
// ===========================================
scrollAnimation({
  className: "serviceArea",
  triggerPoint: 100
});


// ===========================================
// モーダルのスライド
// ===========================================
$(function () {
  $('.memberSlide').each(function(){
    const slide = $(this),
          nav = slide.parent().parent().find('.memberSlideNav');

    slide.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      appendArrows: nav,
      dots: true,
      speed: 250,
    });
  });
});


// ===========================================
// モーダル立ち上げ時に、クリックしたサムネイルに紐づいたモーダルを開く
// ===========================================
$(function () {
  $('.serviceMemberList__item').each(function(){
    const item = $(this),
          target = $('.memberSlide .slick-dots li:nth-child(' + item.attr('data-slide') + ')');

    item.on('click', function(){
      target.click();
    });
  });
});


// ===========================================
// モーダル全体にスクロールを発生させるか判断
// ===========================================
$(function () {
  $('.c-modal__box--member').each(function(){
    const box = $(this),
          slide = box.find('.memberSlide');
    let beforeWidth = $(window).width();

    function scrollSet() {
      if( box.height() < slide.height() ) {
        box.addClass('scroll');
      } else {
        box.removeClass('scroll');
      }
    }

    scrollSet();

    $(window).on('resize', function(){
      if( beforeWidth !== $(window).width() ) {
        scrollSet();
      }
    });
  });
});


// ===========================================
// モーダル内部のレイアウト
// ===========================================
$(function () {
  $('.memberSlide__item').each(function(){
    const item = $(this),
          head = item.find('.memberSlideHead'),
          bodyWrapper = item.find('.memberSlideBodyWrapper'),
          body = bodyWrapper.find('.memberSlideBody'),
          bodyInner = body.find('.memberSlideBodyInner'),
          tmb = item.find('.memberSlide__tmb');
    let beforeWidth = $(window).width();

    function heightSet() {
      bodyWrapper.css({  height: 'auto' });
      body.css({  height: 'auto' });

      if( $(window).width() > 1024 ) {
        bodyWrapper.css({ height: tmb.height() - head.outerHeight() - 52 });
        body.css({ height: tmb.height() - head.outerHeight() - 52 });
      }

      if(
        $(window).width() > 1024 &&
        body.height() < bodyInner.outerHeight()
      ) {
        bodyWrapper.addClass('shadow');
        body.addClass('scroll');
      } else {
        bodyWrapper.removeClass('shadow');
        body.removeClass('scroll');
      }
    }

    heightSet();

    $(window).on('resize', function(){
      if( beforeWidth !== $(window).width() ) {
        heightSet( head, body, tmb );
      }
      beforeWidth = $(window).width();
    });

    body.on('scroll', function(){
      if( body.scrollTop() >= bodyInner.outerHeight() - body.height() -20 ) {
        bodyWrapper.addClass('shadowOff');
      } else {
        bodyWrapper.removeClass('shadowOff');
      }
    });
  });
});